export function get_option_sale(data) {
    let option = {
        title: {
            top: "3",
            left: "center",
            text: "近3年的月度销售发票折线图",
            subtext: ""
        },
        tooltip: {
            trigger: 'axis'
        },
        legend: {
            data: ['销售金额'],
            top: 60
        },
        grid: {
            top: 90,
            show: true
        },
        toolbox: {
            feature: {
                dataView: {
                    show: true,
                    readOnly: false
                },
                magicType: {
                    show: true,
                    type: ['line', 'bar']
                },
                restore: {
                    show: true
                },
                saveAsImage: {}
            }
        },

        dataset: [{
            source: data
        }],
        xAxis: {
            type: 'category',
            boundaryGap: false
        },
        yAxis: [{
                type: 'value',
                name: '金额(元)',
                nameLocation: "middle",
                nameGap: 50
            },

        ],
        series: [{
                name: '销售金额',
                type: 'line',
                smooth: false,
                encode: {
                    x: 'ym',
                    y: 'jshj'
                }
            },
            // {
            //     name: 'N₂O',
            //     type: 'line',
            //     smooth: true,
            //     encode: {
            //         x: 'time_of_data',
            //         y: 'N2O'
            //     },
            //     yAxisIndex: 1,
            // },

        ]
    };
    return option;
}


